import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

const DateRangeWorkshop = (data) => {
    data.sort(function (a, b) {
        var keyA = new Date(a.ws_time_slot.start_time),
            keyB = new Date(b.ws_time_slot.start_time);
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
    });
    const dateStart = new Date(data[0].ws_time_slot.start_time);
    const timeZone = 'Asia/jakarta';
    const patternStart = 'dd MMMM yyyy HH:mm';
    const patternEnd = 'HH:mm';
    const zonedDateStart = utcToZonedTime(dateStart, timeZone);
    var dateEnd;
    if (data.length === 1) {
        dateEnd = data[0].ws_time_slot.end_time;
    } else {
        dateEnd = data[data.length - 1].ws_time_slot.end_time;
    }
    const zonedDateEnd = utcToZonedTime(dateEnd, timeZone);

    return (
        format(zonedDateStart, patternStart) +
        ' - ' +
        format(zonedDateEnd, patternEnd)
    );
};

export default DateRangeWorkshop;
